import { toast } from "sonner";

type ToastOptions = {
  duration?: number;
};

function error(message: string, options?: ToastOptions) {
  toast.error(message, {
    position: "top-right",
    duration: options?.duration ?? 4000,
    style: {
      border: "none",
      backgroundColor: "var(--color-error)",
      color: "white",
    },
  });
}

function info(message: string, options?: ToastOptions) {
  toast.info(message, {
    position: "top-right",
    duration: options?.duration ?? 4000,
    style: {
      border: "none",
      backgroundColor: "var(--color-toast-info-background)",
      color: "var(--color-toast-info-text)",
    },
  });
}

function infoWhite(message: string, options?: ToastOptions) {
  toast.info(message, {
    position: "top-right",
    duration: options?.duration ?? 4000,
    style: {
      border: "none",
      backgroundColor: "white",
      color: "var(--color-text-primary)",
    },
  });
}

export default {
  error,
  info,
  infoWhite,
};
